export function Log(data,includeTime=true){
	const today = new Date();
	const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
	return{
		type:"Log",
		payload:includeTime?`[${time}] ${data}`:data,
	}
}
export function Login(login,token=null,usertype=null,username=null,userid=null){
	return{
		type:"Login",
		payload:login,
		token,
		usertype,
		username,
		userid
	}
}
export function sethomepagePopup(payload){
	return{
		type:"sethomepagePopup",
		payload,
	}
}
export function setlanguage(payload){
	return{
		type:'setlanguage',
		payload
	}
}
export function setuserData(payload){
	return{
		type:'setuserData',
		payload
	}
}